/*jshint esversion: 6 */
export default {
    isNumberKey(evt) {
        var charCode = (evt.which) ? evt.which : event.keyCode
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
            return false;
        }
        return true;
    },
    validateDecimalKeyPress(el, evt) {
        var charCode = (evt.which) ? evt.which : event.keyCode;
        var number = el.value.split('.');
        if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
            return false;
        }
        //just one dot
        if(number.length>1 && charCode == 46){
            evt.preventDefault();
            return false;
        }
        //get the carat position
        var caratPos = this.getSelectionStart(el);
        var dotPos = el.value.indexOf(".");
        if( caratPos > dotPos && dotPos>-1 && (number[1].length > 1)){
            evt.preventDefault();
            return false;
        }
        return true;
    },
    getSelectionStart(o) {
        if (o.createTextRange) {
            var r = document.selection.createRange().duplicate()
            r.moveEnd('character', o.value.length)
            if (r.text == '') return o.value.length
            return o.value.lastIndexOf(r.text)
        } else return o.selectionStart
    },
    openImg(src) {
        let newWindow = window.open("");
        newWindow.document.write(`<iframe width='100%' height='100%' src='${src}'></iframe>`);
        return false;
    },
    openPDF(src) {
        window.open(src);
    }
}
